import { TagsResponse } from '../../models/tags/TagsResponse';

export const getTagLabel = (tags: TagsResponse[], tagId: number | null, alternativeLabel: string) => {
  if (!tagId) {
    return alternativeLabel;
  }

  const tagLabel = findTagResponse(tags, tagId)?.label;
  return tagLabel ? `#${tagLabel}` : alternativeLabel;
};

export const findTagResponse = (tags: TagsResponse[], tagId: number) =>
  tags.find((tag) => tag.id === tagId);
